module.exports = __webpack_public_path__ + "img/icon-question-rating-star-active.ce531dde.svg";